import type { FormInstance } from 'antd';
import { AppstoreOutlined, HistoryOutlined } from '@ant-design/icons';
import type { FormServicoValues } from '@/features/servico/types/Servico';
import type { TabList } from '@/types';
import type { FormAction } from '@/types/FormAction';
import { ServicoTabGeral } from './geral/ServicoTabGeral';
import { ServicoTabHistoricoAlteracao } from './historico-alteracao/ServicoTabHistoricoAlteracao';

export enum ServicoTabKey {
    Geral = 'geral',

    HistoricoAlteracoes = 'historico-alteracoes',
}

export enum ServicoTabKeyHistoricoAlteracao {
    Geral = 'geral',
    PrecoVenda = 'preco-venda',
    PrecoCusto = 'preco-custo',
    CustoMedio = 'custo-medio',
}

export function useServicoTabItems({
    form,
    action,
}: {
    form: FormInstance<FormServicoValues>;
    action: FormAction;
    setFormDirty: (dirty: boolean) => void;
}): TabList<ServicoTabKey>[] {
    const items: TabList<ServicoTabKey>[] = [
        {
            children: <ServicoTabGeral action={action} form={form} />,
            forceRender: true,
            icon: <AppstoreOutlined />,
            key: ServicoTabKey.Geral,
            label: 'Geral',
        },
    ];

    if (action === 'editar') {
        items.push({
            children: <ServicoTabHistoricoAlteracao form={form} />,
            icon: <HistoryOutlined />,
            key: ServicoTabKey.HistoricoAlteracoes,
            label: 'Histórico de alterações',
        });
    }

    return items;
}
